import { authenticatedFetch } from "./authenticatedFetch";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const WHATSAPP_LINK_CODE_PATH =
  import.meta.env.VITE_WHATSAPP_LINK_CODE_PATH ?? "/whatsapp/link-code";

function formatHttpError(payload) {
  if (payload == null) return "Não foi possível gerar o código.";
  if (typeof payload === "string") return payload;
  if (typeof payload === "object") {
    return (
      payload.error ||
      payload.message ||
      payload.detail ||
      "Não foi possível gerar o código."
    );
  }
  return "Não foi possível gerar o código.";
}

async function readJson(response) {
  try {
    return await response.json();
  } catch {
    return null;
  }
}

/**
 * Requests a short-lived WhatsApp account-linking code for the signed-in user.
 *
 * @returns {Promise<
 *   | { ok: true, code: string, expiresIn?: number, businessDisplayNumber?: string }
 *   | { ok: false, message: string }
 * >}
 */
export async function requestWhatsAppLinkCode() {
  try {
    const response = await authenticatedFetch(
      `${API_BASE_URL}${WHATSAPP_LINK_CODE_PATH}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );
    const data = await readJson(response);

    if (!response.ok) {
      return { ok: false, message: formatHttpError(data) };
    }

    const code = data?.code;
    if (!code || typeof code !== "string") {
      return { ok: false, message: "Resposta inválida do servidor." };
    }

    return {
      ok: true,
      code,
      expiresIn: data?.expires_in,
      businessDisplayNumber: data?.business_display_number,
    };
  } catch (error) {
    console.error("requestWhatsAppLinkCode failed:", error);
    return { ok: false, message: "Não foi possível gerar o código." };
  }
}
